/* Components */
import Vue from 'vue';

//Groups
import micros from './micros';

import footerbar from './footerbar.vue';
Vue.component('footerbar', footerbar);

import projectcard from './projectcard.vue';
Vue.component('projectcard', projectcard);

import masthead from './masthead.vue';
Vue.component('masthead', masthead);

import folio from './folio.vue';
Vue.component('folio', folio);

import player from './player.vue';
Vue.component('player', player);

import landscape from './landscape.vue';
Vue.component('landscape', landscape);

import related from './related.vue';
Vue.component('related', related);

import slidetransitions from './slidetransitions.vue';
Vue.component('slidetransitions', slidetransitions);

import password from './password.vue';
Vue.component('password', password);

import imageloader from './imageloader.vue';
Vue.component('imageloader', imageloader);

import counter from './counter.vue';
Vue.component('counter', counter);

import block from './block.vue';
Vue.component('block', block);

import videoloader from './videoloader.vue';
Vue.component('videoloader', videoloader);

import menubutton from './menubutton.vue';
Vue.component('menubutton', menubutton);

import srcset from './srcset.vue';
Vue.component('srcset', srcset);

import introduction from './introduction.vue';
Vue.component('introduction', introduction);

import scroller from './scroller.vue';
Vue.component('scroller', scroller);

import close from './close.vue';
Vue.component('close', close);
